import "core-js/modules/es.array.slice.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  id: "LatestMusic"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HeadNav = _resolveComponent("HeadNav");

  var _component_TagNav = _resolveComponent("TagNav");

  var _component_NewMusic = _resolveComponent("NewMusic");

  var _component_Iscroll = _resolveComponent("Iscroll");

  var _component_NewDisc = _resolveComponent("NewDisc");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 顶部切换导航 "), _createVNode(_component_HeadNav, {
    onNavChange: _ctx.navChange
  }, null, 8
  /* PROPS */
  , ["onNavChange"]), _createCommentVNode(" 标签导航 "), _createVNode(_component_TagNav, {
    ref: "refTagNav",
    tagNav: _ctx.isShow ? _ctx.tagNav : _ctx.tagNav2,
    isShow: _ctx.isShow,
    onTagChangeClick: _ctx.tagChangeClick,
    onRightTagClick: _ctx.rightTagClick
  }, null, 8
  /* PROPS */
  , ["tagNav", "isShow", "onTagChangeClick", "onRightTagClick"]), _createCommentVNode(" 新歌速递页面 "), _ctx.isShow ? (_openBlock(), _createBlock(_component_Iscroll, {
    key: 0,
    onScrollLoad: _ctx.scrollLoad
  }, {
    Iscroll: _withCtx(function () {
      return [_createVNode(_component_NewMusic, {
        newMusicList: _ctx.newMusicList.slice(0, _ctx.loadNum)
      }, null, 8
      /* PROPS */
      , ["newMusicList"])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["onScrollLoad"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 新碟上架页面 "), _createVNode(_component_Iscroll, {
    onScrollLoad: _ctx.scrollLoad
  }, {
    Iscroll: _withCtx(function () {
      return [_createVNode(_component_NewDisc, {
        newDiscList: _ctx.newDiscList.slice(0, _ctx.loadNum)
      }, null, 8
      /* PROPS */
      , ["newDiscList"])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["onScrollLoad"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ))]);
}